if ($('.swiper').hasClass('advertisements__carousel')) {
    const swiper = new Swiper('.advertisements__carousel', {
        // Optional parameters
        slidesPerView: 4,
        slidesPerGroup: 1,
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        // Responsive breakpoints
        breakpoints: {
            280: {
                slidesPerView: 1.4,
            },
            320: {
                slidesPerView: 1.4,
            },
            420: {
                slidesPerView: 1.4,
            },
            640: {
                slidesPerView: 1.4,
            },
            960: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 4,
            }
        },
    });
}
//Homepage slider
let iconsSlidesPerView = 5;
let iconsSlidesPerViewMobile = 5;
let isIconsSlidesPerGroupAuto = false;
let isIconsLoop = true;
if ($('.icons-carousel__module .swiper').attr('data-iconscounter') < 5) {
    iconsSlidesPerView = "auto";
    isIconsLoop = false;
    isIconsSlidesPerGroupAuto = true;
    $('.icons-carousel__module .swiper .swiper-wrapper').css('justify-content', 'center');
}

if ($('.swiper').hasClass('icons__carousel')) {
    const swiper = new Swiper('.icons__carousel', {
        // Optional parameters
        slidesPerView: iconsSlidesPerView,
        slidesPerGroup: 1,
        slidesPerGroupAuto: isIconsSlidesPerGroupAuto,
        direction: 'horizontal',
        loop: isIconsLoop,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next-icons-carousel',
            prevEl: '.swiper-button-prev-icons-carousel',
        },

        // Responsive breakpoints
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            280: {
                slidesPerView: 4,
            },
            320: {
                slidesPerView: 4,
            },
            425: {
                slidesPerView: 4,
            },
            575: {
                slidesPerView: 4,
            },
            800: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 5,
                slidesPerGroup: 1,
            },
        },
    });
}


//Icon grid swiper
if ($('.swiper').hasClass('icon__repeater')) {
    const swiper = new Swiper('.icon__repeater', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 5,
        slidesPerGroup: 1,
        loop: true,
        spaceBetween: 40,

        // Responsive breakpoints
        breakpoints: {
            280: {
                slidesPerView: 1,
            },
            320: {
                slidesPerView: 1,
            },
            575: {
                slidesPerView: 2,
            },
            767: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 4,
            },
            1400: {
                slidesPerView: 5,
            },
        },
    });
}